import { z } from "zod";

/**
 * Lenses: cross-cutting display transforms every block and contribution
 * must respect. They live in the per-user config layer (Tier 0), not in
 * individual contributions.
 *
 * The privacy lens shipped first in webapp-v2
 * (`src/lib/value-format/privacy-lens.ts`); this schema is the durable
 * contract shape it migrates into once config persists server-side.
 */

export const privacyLensSchema = z.object({
  /** Redact user-scoped monetary values; market data stays visible. */
  enabled: z.boolean(),
});

/**
 * Display denomination (syntax only — conversion is a separate concern).
 * ISO 4217 alpha code.
 */
export const denominationLensSchema = z.object({
  currency: z.string().regex(/^[A-Z]{3}$/),
});

export const densityLensSchema = z.object({
  mode: z.enum(["comfortable", "compact"]),
});

export const lensStateSchema = z.object({
  privacy: privacyLensSchema.optional(),
  denomination: denominationLensSchema.optional(),
  density: densityLensSchema.optional(),
});

export type PrivacyLens = z.infer<typeof privacyLensSchema>;
export type DenominationLens = z.infer<typeof denominationLensSchema>;
export type DensityLens = z.infer<typeof densityLensSchema>;
export type LensState = z.infer<typeof lensStateSchema>;
